import { FormattedMessage } from 'react-intl';
import { commonMessages } from '../../../../../atoms/CommonMessages/messages';
import { CircularLogo } from '../../../../../Templates/TemplateColor.styles';
import { Caption, Text } from '../../../../../atoms/Text/Text';
import { FlexBox } from '../../../../../atoms/FlexBox/FlexBox';

type ProviderTitleHeaderProps = {
  providerName: string;
  iconSrc: string;
};

export const ProviderTitleHeader = ({ providerName, iconSrc }: ProviderTitleHeaderProps) => (
  <FlexBox my="normal" style={{ alignItems: 'center' }}>
    <FlexBox mr="xsmall">
      <CircularLogo src={iconSrc} diameter={40} />
    </FlexBox>

    <FlexBox direction="column">
      <Caption color="secondary" mb="none">
        <FormattedMessage {...commonMessages.bank} />
      </Caption>
      <Text bold mb="none">
        {providerName}
      </Text>
    </FlexBox>
  </FlexBox>
);
